var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShortcutsMini = function SvgShortcutsMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    d: "M6.664 12.01a.5.5 0 0 0 .676.002l.18-.165c2.893-2.661 3.798-3.604 4.43-4.793.318-.6.473-1.17.473-1.757 0-1.572-1.21-2.797-2.758-2.797a3.03 3.03 0 0 0-2.282 1.075L7 4.029l-.383-.454A3.03 3.03 0 0 0 4.335 2.5c-1.547 0-2.758 1.225-2.758 2.797 0 .589.156 1.162.478 1.764.633 1.188 1.544 2.136 4.425 4.78z"
  })));
};
export default SvgShortcutsMini;